import "./App.css";
import { routes } from "./routes";
import { useEffect, useRef } from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NotFound from "./components/notFound/NotFound";
import Home from "./pages/home/Home";
import { useSelector } from "react-redux";
import UnBoxing from "./components/Allboxes/UnBoxing";
import Layout from "./components/dashboard/layouts/Layout";
import AllBattle from "./components/All Battles/AllBattle";
import { BoxDetail } from "./components/Allboxes/BoxDetails/BoxDetail";
import Cart from "./pages/cart/Cart.jsx";
import Fairness from "./pages/Fairness/Fairness.jsx";
import Documents from "./pages/documents/Documents.jsx";
import Topups from "./pages/MyaccountTransactions/TopUps.jsx";
import Transactions from "./pages/MyaccountTransactions/Transactions.jsx";
import ProtectedRoutes from "./ProtectedRoutes";
import CreateBattle from "./pages/createBattle/CreateBattle";
import Contact from "./pages/contact-us/Contact";
import Blog from "./pages/Blog/Blog";
import FAQ from "./pages/Faq/Faq.jsx";
import Terms from "./pages/Terms/Terms";
import Privacy from "./pages/Privacy-Payments/Privacy";
import Provably from "./pages/Provably-Fair/ProvablyFair";
import Cookie from "./pages/Cookie/Cookie";
import AmlPolicy from "./pages/AmlPolicy/AmlPolicy";
import BattleDetail from "./components/BattleDetail/BattleDetail";
import ResetPassword from "./pages/ResetPassword/ResetPassword.jsx";
import Withdrawals from "./pages/MyaccountTransactions/Withdrawals.jsx";
import Notificaitons from "./pages/Notificaitons/Notificaitons.jsx";
import { battleWSManager } from "./services/battleWebSocketManager";
import { showBattleNotification } from "./utils/battleNotifications";
import PaymentCallback from "./pages/PaymentCallback/PaymentCallback.jsx";
import FreeBoxes from "./components/FreeBoxes/FreeBoxes.jsx";
import BecomeReferrer from "./pages/becomeReferrer/BecomeReferrer.jsx";
import { registerPusherListeners } from "./pusherListener.js";
import DeleteAccount from "./components/DeleteAccount/DeleteAccount.jsx";
import ProfileLayout from "./components/MyProfile/ProfileLayout.jsx";
import AccountWrapper from "./pages/AccountInfo/AccountWrapper.jsx";
import GameHistory from "./pages/MyaccountTransactions/GameHistory.jsx";
import ComingSoon from "./pages/ComingSoon/ComingSoon.jsx";

function App() {
  const pusherInitialized = useRef(false);
  const lastProcessedEventIdRef = useRef(null);
  const user = useSelector((state) => state?.auth?.user);
  const isDarkMode = useSelector((state) => state?.theme?.darkMode);
  const isLoading = useSelector((state) => state?.loader?.isLoading);
  const lastEvent = useSelector((state) => state?.battle?.lastEvent);

  useEffect(() => {
    if (user?.id && !pusherInitialized.current) {
      registerPusherListeners();
      pusherInitialized.current = true;
    }
  }, [user]);

  useEffect(() => {
    battleWSManager.initialize();
    battleWSManager.subscribeToGeneralChannel();
    return () => {
      battleWSManager.cleanup();
    };
  }, []);

  useEffect(() => {
    if (!lastEvent) return;
    const eventId = lastEvent._id || lastEvent._timestamp;
    if (lastProcessedEventIdRef.current === eventId) {
      return;
    }
    lastProcessedEventIdRef.current = eventId;
    showBattleNotification(lastEvent, user?.id); // ← pass current user's ID
  }, [lastEvent, user]);

  return (
    <div
      className={`${isDarkMode ? "App AppDark" : "App Applight"} ${
        isLoading ? "blur" : ""
      }`}
    >
      <Routes>
        <Route
          path={routes.DEPOSIT_SUCCESSFULL}
          element={<PaymentCallback />}
        />
        <Route
          path={routes.WITHDRAW_SUCCESSFULL}
          element={<PaymentCallback />}
        />
        <Route path={routes.DEPOSIT_FAILED} element={<PaymentCallback />} />
        <Route path={routes.WITHDRAW_FAILED} element={<PaymentCallback />} />

        <Route element={<Layout type="sidebar" />}>
          {/*  <Route path={routes.DEPOSIT} element={<DepositRedirect />} /> */}
          <Route path={routes.HOME} element={<Home />} />
          <Route path={routes.SOCIAL_CALLBACK} element={<Home />} />
          <Route path={routes.SOCIAL_ERROR} element={<Home />} />
          <Route path={routes.VERIFICATION_CALLBACK} element={<Home />} />
          <Route path={routes.VERIFICATION_ERROR} element={<Home />} />
          <Route path={routes.VERIFICATION_EXPIRED} element={<Home />} />
          <Route path={routes.UNBOXES} element={<UnBoxing />} />
          <Route path={`${routes.BOXDETAIL}/:slugId`} element={<BoxDetail />} />
          <Route path={routes.SIGN_UP} element={<Home />} />
          <Route path={routes.BATTLES} element={<AllBattle />} />
          <Route
            path={`${routes.BATTLEDETAIL}/:slugId`}
            element={<BattleDetail />}
          />
          <Route path={routes.CREATEBATTLE} element={<CreateBattle />} />
          <Route path={routes.CONTACTUS} element={<Contact />} />
          <Route path={routes.BECOMEREFERRER} element={<BecomeReferrer />} />
          <Route path={routes.BLOG} element={<Blog />} />
          <Route path={routes.FAQ} element={<FAQ />} />
          <Route path={routes.TERMS} element={<Terms />} />
          <Route path={routes.PRIVACYPAYMENTS} element={<Privacy />} />
          <Route path={routes.PROVABLYFAIR} element={<Provably />} />
          <Route path={routes.COOKIE} element={<Cookie />} />
          <Route path={routes.AMLPOLICY} element={<AmlPolicy />} />
          <Route path={routes.RESET} element={<ResetPassword />} />
          <Route path={routes.NOTIFICATIONS} element={<Notificaitons />} />
          <Route path={routes.CART} element={<Cart />} />

          {/* Account Layout with top navigation - All nested routes */}
          <Route
            path={routes.ACCOUNT}
            element={
              <ProtectedRoutes>
                <ProfileLayout />
              </ProtectedRoutes>
            }
          >
            <Route index element={<AccountWrapper />} />

            <Route path={routes.ACCOUNT_FAIRNESS} element={<Fairness />} />
            <Route path={routes.ACCOUNT_DOCUMENTS} element={<Documents />} />
            <Route path={routes.ACCOUNT_FREEBOXES} element={<FreeBoxes />} />
            <Route path={routes.ACCOUNT_TOPUPS} element={<Topups />} />
            <Route
              path={routes.ACCOUNT_WITHDRAWALS}
              element={<Withdrawals />}
            />
            <Route
              path={routes.ACCOUNT_GAMEHISTORY}
              element={<GameHistory />}
            />
            <Route
              path={routes.ACCOUNT_TRANSACTIONS}
              element={<Transactions />}
            />
            <Route path={routes.ACCOUNT_FREEBOXES} element={<FreeBoxes />} />
            <Route
              path={routes.ACCOUNT_DELETEACCOUNT}
              element={<DeleteAccount />}
            />
          </Route>
          <Route path={routes.COMINGSOON} element={<ComingSoon />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>

      <ToastContainer
        newestOnTop
        closeOnClick
        draggable
        pauseOnHover
        limit={5}
        theme={isDarkMode ? "dark" : "light"}
      />
    </div>
  );
}

export default App;
